"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const sha256 = async (input) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(input);
  const cryptoSubtle = typeof window !== "undefined" && window.crypto && window.crypto.subtle || globalThis.crypto && globalThis.crypto.subtle;
  if (!cryptoSubtle) {
    const errorMessage = "Web Crypto API is not available in this environment. Enable HTTPS for local development to use the Web Crypto API.";
    throw new Error(errorMessage);
  }
  const hashBuffer = await cryptoSubtle.digest("SHA-256", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
  return hashHex;
};
exports.sha256 = sha256;
//# sourceMappingURL=sha256.js.map
